<div class="header-bar">
  <div class="header-left">
    <div class="header-text">Template Library</div>
    <div class="divider"></div>
    <div class="search-box input-box">
      <svg-icon src="assets/svg/magnifier.svg"></svg-icon>

      <mat-form-field>
        <input matInput type="text" [formControl]="searchValueControl" />
      </mat-form-field>
    </div>
    <div class="divider"></div>

    <div class="filter">
      <button mat-button class="icon-btn" (click)="toggleFilterDialog()">
        <svg-icon src="assets/svg/filter.svg" svgClass="grey"></svg-icon>
      </button>
    </div>
  </div>
  <div class="header-center"></div>
  <div class="header-right">
    <button
      *ngIf="showCreateAndEdit"
      mat-button
      color="lightGreen"
      (click)="createNewTemplate()"
    >
      Create New Template
    </button>
  </div>
</div>

<div class="template-library">
  <div class="container template-list-container">
    <div class="container-header no-bottom-border">
      <div class="text">Template list</div>
      <div class="options">
        <button
          *ngIf="showCreateAndEdit"
          mat-icon-button
          [matMenuTriggerFor]="templateMenu"
        >
          <svg-icon src="assets/svg/ellipsis.svg"></svg-icon>
        </button>
        <mat-menu
          class="mat-menu-elaphant vertical-menu"
          #templateMenu="matMenu"
        >
          <button
            class="icon-btn-w-text"
            mat-menu-item
            (click)="createNewTemplate()"
          >
            <svg-icon src="assets/svg/plus-circle-white.svg"></svg-icon>
            <span>Create New Template</span>
          </button>
        </mat-menu>
      </div>
    </div>
    <div
      class="container-content"
      lhpeElementLoader
      #templateElementLoader="elementloader"
    >
      <table #templateTable mat-table [dataSource]="templateDataSource" matSort>
        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef>Type</th>
          <td mat-cell *matCellDef="let row">Mobile</td>
        </ng-container>

        <ng-container matColumnDef="layout">
          <th mat-header-cell *matHeaderCellDef>Layout</th>
          <td mat-cell *matCellDef="let row">
            <!-- {{ row.name ? row.name : "-" }} -->
            -
          </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
          <td mat-cell *matCellDef="let row">
            {{ row.name ? row.name : "-" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="header_image">
          <th mat-header-cell *matHeaderCellDef>Header image</th>
          <td mat-cell *matCellDef="let row">
            {{ row.header_image ? row.header_image : "-" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="background_image">
          <th mat-header-cell *matHeaderCellDef>Background image</th>
          <td mat-cell *matCellDef="let row">
            {{ row.background_image ? row.background_image : "-" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="created_at">
          <th mat-header-cell *matHeaderCellDef>Created by</th>
          <td mat-cell *matCellDef="let row">
            {{ row.created_by_name ? row.created_by_name : "-" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="options">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row" class="options-cell">
            <button
              *ngIf="showView"
              mat-button
              (click)="viewTemplate(row)"
              class="icon-btn"
            >
              <svg-icon
                src="assets/svg/view.svg"
                svgClass="lightBlue"
              ></svg-icon>
            </button>
            <div *ngIf="!showView" class="empty-btn-space"></div>

            <button
              *ngIf="showCreateAndEdit"
              mat-button
              (click)="editTemplate(row)"
              class="icon-btn"
            >
              <svg-icon
                src="assets/svg/pencil.svg"
                svgClass="lightBlue"
              ></svg-icon>
            </button>
            <div *ngIf="!showCreateAndEdit" class="empty-btn-space"></div>

            <button
              *ngIf="showDelete"
              class="icon-btn"
              mat-button
              (click)="deleteTemplate(row)"
            >
              <svg-icon
                src="assets/svg/trashcan.svg"
                [svgStyle]="{
                  'width.px': '15.25',
                  'height.px': '16.204'
                }"
                svgClass="lightBlue"
              ></svg-icon>
            </button>
            <div *ngIf="!showDelete" class="empty-btn-space"></div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
      <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="perPage" (page)="onPageChange($event)"></mat-paginator>
    </div>
  </div>
</div>
